var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pageView",staticClass:"page-view container-view"},[_c('section',{staticClass:"title-section fixed-view"},[_c('e6-title',[_vm._v(" 自定义考核内容 "),_c('template',{slot:"breadcrumb"},[_c('e6-breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}})],1)],2)],1),_c('section',{staticClass:"content-section"},[_c('self-assessment-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }